export default __webpack_public_path__ + "static/media/7.9ec58728.png";